import React from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyle = makeStyles(() => ({
  container: {
    width: '100vw',
    height: '100vh',
    textAlign: 'center'
  }
}));

const PageNotFound = () => {
  const classes = useStyle();
  return (
    <Grid container alignItems="center" justify="center" className={classes.container}>
      <Grid item>
        <Typography variant="h4">Error 404: Page Not Found</Typography>
        <Typography>The link you followed may be broken, or the page may have been removed.</Typography>
        <Link to="/">Go to Home</Link>
      </Grid>
    </Grid>
  );
};

export default PageNotFound;
